const creditCardManagement = {
  removeCard: 'Remover',
};

export default creditCardManagement;
